import { render } from "./InputSections.vue?vue&type=template&id=c5c77ca4&scoped=true"
import script from "./InputSections.vue?vue&type=script&lang=js"
export * from "./InputSections.vue?vue&type=script&lang=js"

import "./InputSections.vue?vue&type=style&index=0&id=c5c77ca4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c77ca4"]])

export default __exports__